import _ from "lodash"
import { useMemo } from "react"
import { getMacros } from "authoring/routes/macro/controller/get-macros"

const { keyBy } = _

export function useMacros({ retrieveDeleted = false } = {}) {
    const { data: macros, loading, error } = getMacros.useResults.status({ retrieveDeleted })

    const list = useMemo(() => macros ?? [], [macros])
    const macroMap = useMemo(() => keyBy(list, "id"), [list])

    return { macros: list, macroMap, loading, error }
}

/** Loads macros once per mount; ignores cache invalidations (schedule editor hot path). */
export function useMacrosOnce({ retrieveDeleted = false } = {}) {
    const data = getMacros.useResultsOnce({ retrieveDeleted })
    const list = useMemo(() => (Array.isArray(data) ? data : []), [data])
    const macroMap = useMemo(() => keyBy(list, "id"), [list])

    return { macros: list, macroMap, loading: data === undefined, error: null }
}
